export const environment = {
  production: true,
  hosts: [
    { prefix: '/api', target: 'https://api.videodownload.me/api/v1' },
  ],
  // http://192.168.1.213:11045/api/v1
};